import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'

import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import ProviderMarkup from '../entities/flight/providerMarkup'

interface ProviderMarkupState extends ListState<ProviderMarkup> {
    providerMarkup: ProviderMarkup,
    editProviderMarkup: ProviderMarkup,
}

class ProviderMarkupMutations extends ListMutations<ProviderMarkup> {
}

class ProviderMarkupModule extends ListModule<ProviderMarkupState, any, ProviderMarkup> {
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<ProviderMarkup>(),
        loading: false,
        editProviderMarkup: new ProviderMarkup(),
        selectProviderMarkup: new ProviderMarkup(),
    }

    actions = {
        async addProviderMarkup(context: ActionContext<ProviderMarkupState, any>, payload: any) {
            let response = await Ajax.post(
                '/api/services/app/Flight/AddProviderMarkup',
                payload.data
            );
        },

        async saveProviderMarkup(context: ActionContext<ProviderMarkupState, any>, payload: any) {
            let response = await Ajax.post(
                '/api/services/app/Flight/SaveProviderMarkup',
                payload.data
            );
        },

        async getProviderMarkups(context: ActionContext<ProviderMarkupState, any>, payload: any) {
            context.state.loading = true;
            let response = await Ajax.get('/api/services/app/Flight/GetProviderMarkups', payload.data);
            console.log(response);
            context.state.loading = false;
            let page = response.data.result as PageResult<ProviderMarkup>;

            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },

        async deleteProviderMarkup(context: ActionContext<ProviderMarkupState, any>, payload: any) {
            await Ajax.delete(
                '/api/services/app/Flight/DeleteProviderMarkup?id=' + payload.payload
            );
        },
    };

    mutations = {
        setCurrentPage(state: ProviderMarkupState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: ProviderMarkupState, pagesize: number) {
            state.pageSize = pagesize;
        },
    }
}

const providerMarkupModule = new ProviderMarkupModule();
export default providerMarkupModule;


